import { render, staticRenderFns } from "./SSSAwardEndorse.vue?vue&type=template&id=472fe3da&v-if=isLoggedIn&"
import script from "./SSSAwardEndorse.vue?vue&type=script&lang=js&"
export * from "./SSSAwardEndorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports